import { sendAnalytics } from '../../../../telemetry/client';
import type { QuickstartState } from '../../QuickstartCoordinator';
import type { BaseAnalyticsProps } from '../IQuickstartTelemetryManager';

export function sendWebSocketConnectionStartedEvent(
  baseProps: BaseAnalyticsProps,
  playerAuthId: string | undefined,
  isFastStart: boolean,
): void {
  sendAnalytics({
    name: 'WebSocket Connection Started',
    role: 'player',
    ...baseProps,
    playerAuthId,
    isFastStart,
  });
}

export function sendWebSocketReadyEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
): void {
  sendAnalytics({
    name: 'WebSocket Ready',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
  });
}

export function sendOAuthReturnDetectedEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
  hasAuthId: boolean,
): void {
  sendAnalytics({
    name: 'OAuth Return Detected',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
    hasAuthId,
  });
}

export function sendLobbyCreationStartedEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
): void {
  sendAnalytics({
    name: 'Lobby Creation Started',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
  });
}

export function sendPeerIdAcquiredEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
  peerId: string,
): void {
  sendAnalytics({
    name: 'Peer ID Acquired',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
    peerId,
  });
}

export function sendSdpOfferSentEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
): void {
  sendAnalytics({
    name: 'SDP Offer Sent',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
  });
}

export function sendSdpAnswerReceivedEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
): void {
  sendAnalytics({
    name: 'SDP Answer Received',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
  });
}

export function sendIceCandidatesSentEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
  candidateCount: number,
): void {
  sendAnalytics({
    name: 'ICE Candidates Sent',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
    candidateCount,
  });
}

export function sendIceCheckingStartedEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
): void {
  sendAnalytics({
    name: 'ICE Checking Started',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
  });
}

export function sendIceConnectedEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
): void {
  sendAnalytics({
    name: 'ICE Connected',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
  });
}

export function sendRemoteStreamReceivedEvent(
  baseProps: BaseAnalyticsProps,
  state: QuickstartState,
  playerAuthId: string | undefined,
): void {
  sendAnalytics({
    name: 'Remote Stream Received',
    role: 'player',
    ...baseProps,
    playerAuthId,
    sessionId: state.sessionId,
  });
}
